import React from "react";
// Material ui components
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
// Styles
import { withStyles } from "@material-ui/core/styles";

const HelpTypography = withStyles({
  root: {
    margin: "10px 0px 10px 0px"
  }
})(Typography);

export const profile = {
  general: (
    <HelpTypography variant="body2">
      This is a place for custom content for help determined by current view. Click here if you wan't to find out more
      about <Link>profile</Link>.
    </HelpTypography>
  ),
  select: false,
  stepper: false
};

export const dashboard = {
  general: (
    <HelpTypography variant="body2">
      This is a place for custom content for help determined by current view. Click here if you wan't to find out more
      about <Link>dashboard</Link>.
    </HelpTypography>
  ),
  select: false,
  stepper: false
};

export const connections = {
  general: (
    <div>
      <HelpTypography variant="h6">Enabled Connectors</HelpTypography>
      <HelpTypography variant="body2">
        Specific informations for enabled connectors with link to <Link>learn more</Link>
      </HelpTypography>
      <HelpTypography variant="h6">Popular Connectors</HelpTypography>
      <HelpTypography variant="body2">
        Specific informations for popular connectors with link to <Link>learn more</Link>
      </HelpTypography>
    </div>
  ),
  select: ["Salesforce", "Outlook", "Zoho"],
  stepper: {
    salesforce: {
      titles: ["Login", "Set Account", "Connect"],
      instructions: step => {
        switch (step) {
          case 0:
            return `Salesforceeee.`;
          case 1:
            return "An ad group contains one or more ads which target a shared set of keywords.";
          case 2:
            return `Try out different ad text to see what brings in the most customers,
                    and learn how to enhance your ads using features like ad extensions.
                    If you run into any problems with your ads, find out how to tell if
                    they're running and how to resolve approval issues.`;
          default:
            return "Unknown step";
        }
      }
    },
    zoho: {
      titles: ["Login", "Set Account", "Connect"],
      instructions: step => {
        switch (step) {
          case 0:
            return `Zohoooooo.`;
          case 1:
            return "An ad group contains one or more ads which target a shared set of keywords.";
          case 2:
            return `Try out different ad text to see what brings in the most customers,
                    and learn how to enhance your ads using features like ad extensions.
                    If you run into any problems with your ads, find out how to tell if
                    they're running and how to resolve approval issues.`;
          default:
            return "Unknown step";
        }
      }
    },
    outlook: {
      titles: ["Login", "Set Account", "Connect"],
      instructions: step => {
        switch (step) {
          case 0:
            return `Outlookkkkkkkkkkkk.`;
          case 1:
            return "An ad group contains one or more ads which target a shared set of keywords.";
          case 2:
            return `Try out different ad text to see what brings in the most customers,
                    and learn how to enhance your ads using features like ad extensions.
                    If you run into any problems with your ads, find out how to tell if
                    they're running and how to resolve approval issues.`;
          default:
            return "Unknown step";
        }
      }
    }
  }
};
